import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../../../lib/api";
import { addDays } from "../../../lib/goal-stats";

export function useDashboardData() {
  const todayDashboard = useQuery({
    queryKey: ["today-dashboard"],
    queryFn: () => apiClient.getTodayDashboard(),
    refetchInterval: 60_000,
  });
  const localDate = todayDashboard.data?.localDate;

  const me = useQuery({
    queryKey: ["me"],
    queryFn: () => apiClient.getCurrentUser(),
    staleTime: 5 * 60 * 1000,
  });

  const todayEntry = useQuery({
    queryKey: ["today-entry"],
    queryFn: () => apiClient.getTodayEntry(),
    staleTime: 60 * 1000,
  });

  const yesterdayEntries = useQuery({
    queryKey: [
      "daily-entries",
      localDate ? addDays(localDate, -1) : "",
      localDate ? addDays(localDate, -1) : "",
    ],
    queryFn: () => {
      const yesterday = addDays(localDate!, -1);
      return apiClient.getDailyEntries(yesterday, yesterday);
    },
    enabled: !!localDate,
    staleTime: 5 * 60 * 1000,
  });

  const historyResponse = useQuery({
    queryKey: ["goal-history-30d"],
    queryFn: () => apiClient.getDailyGoalHistory(addDays(localDate!, -30), addDays(localDate!, -1)),
    enabled: !!localDate,
    staleTime: 5 * 60 * 1000,
  });

  return { todayDashboard, me, todayEntry, yesterdayEntries, historyResponse };
}
